module.exports = __webpack_public_path__ + "static/raf-94f0526c64974ba751c7281af286c94c.jpg";